module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/umbrella.svg?ffae4d9c4d4d1d988c015b0f4254423f";